import React from "react";
import { motion } from "framer-motion";

import { googlePLay } from "../../SVG";
import Mock1 from "../../assets/Mock1.png";
import Mock2 from "../../assets/Mock2.png";
import classes from "./DownloadSection.module.css";

const DownloadSection = (props) => {
  return (
    <div className={classes.DownloadSection}>
      <div className={classes.MockupContainer}>
        <motion.img
          initial={{ y: "12%", x: "80%" }}
          animate={{ y: "20%", x: "80%" }}
          transition={{ yoyo: Infinity, duration: 1.8 }}
          className={classes.Mock1}
          src={Mock1}
          alt="Mock ups"
        />
        <motion.img
          initial={{ y: "-15%", x: "-80%", rotateY: "180deg" }}
          animate={{ y: "-20%", x: "-80%", rotateY: "180deg" }}
          transition={{ yoyo: Infinity, duration: 1.4 }}
          className={classes.Mock2}
          src={Mock2}
          alt="Mock ups"
        />
      </div>
      <div className={classes.Description}>
        <div className={classes.Para}>
          <div className={classes.Name}>Alo Foodie</div>Alo foodie is available
          now in KANYAKUMARI Whether you’re looking for biryani to feed your
          desi cravings, soul comforting pizzas and burgers, or even a salad
          with a cup of chai or coffee, Alo foodie is the only app you need for
          the quickest doorstep delivery of your favorites.
          <div className={classes.GooglePlay}>
            <a href="https://play.google.com/store/apps/details?id=com.ALO_Foodie_alo_foodie">
              {googlePLay}
              <div>Get It On Google Play</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadSection;
